module.exports = __webpack_public_path__ + "static/logo-h-f54dc4a04f7d6bbd8d91cd28630701f5.svg";